@if (fullPageLayout) {
    <router-outlet></router-outlet>
}
@if (!fullPageLayout) {
    <pf-app-layout>
        <pf-app-header>
            <pf-tenant-selector
                header-actions
                pfFirebendAdmin></pf-tenant-selector>
        </pf-app-header>
        @if (!layoutService.isHidden) {
            <pf-app-nav-menu
                [navigation]="appRouter.navigation"></pf-app-nav-menu>
        }
    </pf-app-layout>
}
